import(/* webpackMode: "eager" */ "/app/src/app/dev/(console)/apps/page.tsx");
